import { useId } from 'react'
import { cn } from '@/shared/lib/utils'

// Decorative brand texture drawn with an SVG pattern rather than a CSS colour
// ramp, since this app uses solid colours only.
export function BrandPattern({ className }: { className?: string }) {
  const dots = useId()
  const lens = useId()

  return (
    <svg
      className={cn('pointer-events-none absolute inset-0 h-full w-full', className)}
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <pattern id={dots} width="28" height="28" patternUnits="userSpaceOnUse">
          <circle cx="2" cy="2" r="1.5" fill="currentColor" />
        </pattern>
        <pattern id={lens} width="180" height="180" patternUnits="userSpaceOnUse">
          <path
            d="M10 90c40-52 120-52 160 0-40 52-120 52-160 0z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
        </pattern>
      </defs>

      <rect width="100%" height="100%" fill={`url(#${dots})`} opacity="0.16" />
      <rect width="100%" height="100%" fill={`url(#${lens})`} opacity="0.07" />
    </svg>
  )
}

export function BrandWordmark({
  tone = 'light',
  className,
}: {
  tone?: 'light' | 'dark'
  className?: string
}) {
  return (
    <img
      src={tone === 'dark' ? '/logo-wordmark-white.png' : '/logo-wordmark.png'}
      alt="PSN Fintech"
      width={235}
      height={42}
      className={cn('h-10 w-auto object-contain', className)}
    />
  )
}
